import React from "react";

// Single source of truth for the DistributeMusic.AI brand mark.
// Uses the uploaded logo (orange tile with sound-wave bars).
export default function BrandLogo({ size = 28, showWordmark = true, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/logo-mark.png"
        alt="DistributeMusic.AI"
        width={size}
        height={size}
        className="rounded-[6px] object-cover"
        style={{ width: size, height: size }}
      />
      {showWordmark && (
        <span className="inline font-display font-semibold tracking-tight whitespace-nowrap text-[13px] sm:text-base">
          DistributeMusic<span className="text-[#FF4500]">.AI</span>
        </span>
      )}
    </span>
  );
}
